export default __webpack_public_path__ + "static/media/Rectangle2.e57e88c3.png";